/* globals isClient DEBUG */
// rc-tooltip
import 'rc-tooltip/assets/bootstrap.css'

import React from 'react'
import {connect} from 'react-redux'
import cs from 'classnames'
import styles from './main.scss'
import {locs} from 'state/location'
import {NEWS, OFFICE, B2B, CLIENTS, PRIVACY, LOGIN} from 'state/constants'
import Helmet from 'react-helmet'
import Loader from './loader'
import CookieBar from './CookieBar'
import Auth from './auth/auth'
import ga from 'react-ga'
import keydown from 'react-keydown'
import Grail from '../elements/Grail'
import NotificationSystem from 'react-notification-system'
import Modal from 'react-modal'
import Privacy from './privacy/privacy'
import i18n from 'lib/i18n'
const _ = i18n('clientZoom')
import InfoModal from './generalComponents/infoModal'
import Header from './mainComponents/Header'

import {setAppModule, toggleMenu, toggleSubMenu, setOpened, setB2bCompanyOpened, logout,
    clearNotification, changeAuthState, setB2BInsuranceCompany, setClientSubModule,
    setB2bCompanySubModule, acceptCookies, validateCookie, setVersionCheckNotification} from 'state/actions'

const Sidebar = isClient ? require('./mainComponents/sidebarMyeasinsure') : require('./mainComponents/sidebar')
const MetroUI = isClient ? null : require('./metroUI')
const Content = isClient ? null : require('./content')
const ClientMain = isClient ? require('./Easinsure') : null

// Remove false to get accessability warnings
if (DEBUG && false) { // eslint-disable-line no-constant-condition
	const a11y = require('react-a11y')
	a11y(React)
}

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '1em',
    },
}


@connect(({app, responsive, auth, dict, categories, sources, clientProfileForm, clients,
        b2bCompany, emailSender}) => ({
	module: app.module,
	redrawMe: app.lang + dict._gen + categories._gen + sources._gen,
	loading: app.loading,
	isLoggedIn: auth.isLoggedIn,
	resetPassword: app.resetPassword,
	authState: auth.authState,
	menuCollapsed: app.menuCollapsed,
	subMenuCollapsed: app.subMenuCollapsed,
	isPhone: responsive.isPhone,
	isTablet: responsive.isTablet,
	backButton: Boolean(app.opened),
	emailSenderIsOpen: Boolean(emailSender.emailModalIsOpen),
	okCookies: Boolean(auth.cookiesAccepted),
	notification: app.notification,
	clientProfileFormStatus: clientProfileForm.formStatus.sent,
	subModule: clients.subModule,
	subModuleB2B: b2bCompany.subModule,
    versionCheckNotification: app.versionCheckNotification
}))
export default class Main extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		module: React.PropTypes.string,
		isPhone: React.PropTypes.bool,
		isTablet: React.PropTypes.bool,
		isLoggedIn: React.PropTypes.bool.isRequired,
		authState: React.PropTypes.string,
		resetPassword: React.PropTypes.bool,
		loading: React.PropTypes.number.isRequired,
		menuCollapsed: React.PropTypes.bool,
		subMenuCollapsed: React.PropTypes.bool,
		backButton: React.PropTypes.bool.isRequired,
		emailSenderIsOpen: React.PropTypes.bool.isRequired,
		onClick: React.PropTypes.func,
		okCookies: React.PropTypes.bool,
	}
	constructor(props) {
		super(props)
		this.prevModule = "start"
		this.state = {modalIsOpen: false, navigationData: {name: '', fromMetroUI: '', isSubmenuItem: '', submenuItem: false, module: ''}}
	}

	openModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }

	componentDidMount() {this.mountOrUpdateStuff()}
	componentDidUpdate() {this.mountOrUpdateStuff()}
	mountOrUpdateStuff() {
		const {module, notification, resetPassword, okCookies, dispatch} = this.props

		if (resetPassword === true) {
			dispatch(changeAuthState('passwordChange'))
		}

		const gaModule = module || 'metroUI'
		if (this.prevModule !== gaModule) {
			ga.pageview(gaModule)
			this.prevModule = gaModule
		}

		if (notification) {
			this.addNotification(notification)
			dispatch(clearNotification())
		}

		if (okCookies) {
			dispatch(validateCookie())
		}
    }
    /**
     * This function handle a click on menu items, switch module in general.
     */
	handleItemClicked = (name, fromMetroUI, isSubmenuItem, submenuItem = false) => {
		const {dispatch, isPhone, isTablet, menuCollapsed, clientProfileFormStatus} = this.props
		const module = locs[name]
		const modalIsOpen = this.state.modalIsOpen

		if(clientProfileFormStatus != undefined && this.props.module != undefined &&
			 this.props.module == CLIENTS
			 && clientProfileFormStatus == false && this.props.subModule == 'edit-profile')
		{
			let currentItemOptions = {
				name: name,
				fromMetroUI: fromMetroUI,
				isSubmenuItem: isSubmenuItem,
				submenuItem: submenuItem,
				insideModulePage: 'client'
			}

			this.setState({navigationData: currentItemOptions})
			this.openModal();
		}
		else if(clientProfileFormStatus != undefined && this.props.module != undefined &&
				clientProfileFormStatus == false && this.props.subModuleB2B == 'edit-profile' &&
            (this.props.module == 'B2B'
                || this.props.module == 'insuranceCompany2321'
                || this.props.module == 'insuranceCompany2320')
            )
		{
			let currentItemOptions = {
				name: name,
				fromMetroUI: fromMetroUI,
				isSubmenuItem: isSubmenuItem,
				submenuItem: submenuItem,
				insideModulePage: 'b2b'
			}

			this.setState({navigationData: currentItemOptions})
			this.openModal();
		}
		else
		{
			if ((isPhone || isTablet) && !menuCollapsed) {
				dispatch(toggleMenu())
			}

			if (isSubmenuItem) {
				dispatch(setB2BInsuranceCompany({companyId:submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel} || false))
			}

			// If you come from metroUi and instantly need to open the b2b submenu
			dispatch(toggleSubMenu((Boolean(fromMetroUI) && name === 'b2b') || isSubmenuItem || false))
			dispatch(setAppModule(module))
		}
	}

	leaveModal()
	{
		const {dispatch, isPhone, isTablet, menuCollapsed, clientProfileFormStatus} = this.props
		const {name, fromMetroUI, isSubmenuItem, submenuItem, insideModulePage } = this.state.navigationData
		const module = locs[name]

		if(insideModulePage == 'client')
		{
			dispatch(setClientSubModule(''));
		}

		if(insideModulePage == 'b2b')
		{
			dispatch(setB2bCompanySubModule(''));
		}

		if ((isPhone || isTablet)  && !menuCollapsed) {
			dispatch(toggleMenu())
		}

		if (isSubmenuItem) {
			dispatch(setB2BInsuranceCompany({companyId:submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel} || false))
		}

		// If you come from metroUi and instantly need to open the b2b submenu
		dispatch(toggleSubMenu((Boolean(fromMetroUI) && name === 'b2b') || isSubmenuItem || false))
		dispatch(setAppModule(module))

		this.setState({navigationData: {name: '', fromMetroUI: '', isSubmenuItem: '', submenuItem: false}})

		this.openModal()
	}

	// for opening submenu in sidebar
	handleToggleSubmenu = (name) => {
		const {dispatch, subMenuCollapsed} = this.props
		const module = locs[name]
		dispatch(toggleSubMenu())
		dispatch(setAppModule(module))
	}

	handleMetroItemClicked = name => { this.handleItemClicked(name, true) }
	goToMetro = () => {this.handleItemClicked(null)}
	handleBackClicked = () => {
		this.props.dispatch(setOpened())
		this.props.dispatch(setB2bCompanyOpened())
	}
	handleFlashClicked = (id) => {this.props.dispatch(setAppModule(NEWS, id))}
	handleLogout = () => {this.props.dispatch(logout())}
	toggleMenu = () => {this.props.dispatch(toggleMenu())}

	@keydown(27)
	submit(event) {
        // prevent back in special cases
        if (!this.props.backButton || this.props.emailSenderIsOpen ||
            this.props.module === OFFICE
        ) {return}

        event.preventDefault()
		this.props.dispatch(setOpened())
		this.props.dispatch(setB2bCompanyOpened())
	}
	addNotification({msg, nType}) {
		this.notificationSystem.addNotification({
			message: msg,
			level: nType,
		})
	}

	handleAcceptCookies = () => {
		this.props.dispatch(acceptCookies());
	}

    render() {
        const { onClick, module, loading, isLoggedIn, authState, menuCollapsed, subMenuCollapsed,
            isPhone, isTablet, backButton, redrawMe, okCookies, versionCheckNotification } = this.props
        const menuActive = !menuCollapsed
        const { modalIsOpen } = this.state
        const showSidebar = Boolean((/**(isClient && (isPhone || isTablet)) ||**/ !isClient) && isLoggedIn && module && (!isPhone || !isTablet || menuActive))

        let content

        if (module == PRIVACY) {
            content = <Privacy />
        } else {
            if (!isLoggedIn || authState === "passwordChange") {
                content = <Auth />
            } else {
                if (isClient) {
                    content = <ClientMain />
                } else {
                    if (module) {
                        content = (
                            <Content
                                onLinkClicked={this.handleItemClicked}
                                onBackClicked={this.handleBackClicked}
                            />
                        )
                    } else {
                        content = (
                            <MetroUI
                                onFlashClicked={this.handleFlashClicked}
                                onLinkClicked={this.handleMetroItemClicked}
                                onLogout={this.handleLogout}
                            />
                        )
                    }
                }
            }
        }

        let nav = showSidebar && (
            <Sidebar
                onLinkClicked={this.handleItemClicked}
                onLogout={this.handleLogout}
                onSubmenuClick={this.handleToggleSubmenu}
                subMenuCollapsed={subMenuCollapsed}
            />
        )

        /**

                    let header = isLoggedIn ? (
                    !isClient && isPhone && isLoggedIn && module && (
                        <PhoneHeaderDom
                            {...{
                                backButton,
                                menuActive,
                                onHome: this.goToMetro,
                                onBack: this.handleBackClicked,
                                onMenu: this.toggleMenu,
                            }}
                        />
                    )
                ) : (
                    <UpdateBar/>
                )

         */

        // !!! IMPORTANT NOTE !!! the reason why is destructured a newly created object to give the values as props is
        // that if you give a prop like isPhone, that means a true inside the component, but if you give a prop like
        // isPhone={isPhone} that forward the value of the isPhone variabel inside the component
        // alernative way to do that: isPhone={isPhone} isClient={isClient} isLoggedIn={isLoggedIn} module={module} etc...
        let header = <Header
            {...{
                isLoggedIn,
                isClient,
                isPhone,
				isTablet,
                module,
                backButton,
                menuActive,
                onHome: () => this.goToMetro(),
                onBack: () => this.handleBackClicked(),
                onMenu: () => this.toggleMenu()
            }}
        />

		const footer = !(okCookies) && <CookieBar handleAcceptCookies={this.handleAcceptCookies}/>


        //----------------------------
        //test data
        const informModalOpen = true

		return (
			<Grail
				stretch
				key={redrawMe}
				onClick={onClick}
				{...{header, nav, footer}}
			>
				<div className={styles.wrapApp}>
					<Helmet title={isClient ? "My Easinsure" : "Willemot"}/>
					{loading > 0 && <Loader/>}
					<NotificationSystem ref={el => {this.notificationSystem = el}}/>

					{content}

					<Modal
						isOpen={modalIsOpen}
						style={customStyles}
						contentLabel="Modal"
					>
						<div className={styles.verifyModalContent}>
							<span className={styles.title}>{_('clientProfileLeavePopup')}</span>
							<span className={styles.message}>{_('clientProfileLeavePopupMessage')}</span>
							<div className={styles.verifyModalButtons}>
						<span
							onClick={() => this.openModal()}
							className={styles.cancel}
						>
							{_("cancel")}
						</span>
								<input
									onClick={() => this.leaveModal()}
									type="button"
									className={styles.greyButton + " enabled"}
									value={_("clientProfileLeaveOkButton")}
								/>
							</div>
						</div>
					</Modal>
                    <InfoModal
                        isOpen={Boolean(versionCheckNotification.isOpened)}
                        style={customStyles}
                        title={versionCheckNotification.title}
                        content={versionCheckNotification.msg}
                        onCancel={()=>{}}
                        onConfirmation={()=>{
                            this.props.dispatch(setVersionCheckNotification(false))
                            this.props.dispatch(setAppModule())
                            this.props.dispatch(logout())
                        }}
                        cancelLabel={_("cancel")}
                        confirmationLabel={_("ok")}
                        options={{noCancelButton: true}}
                    />
				</div>
			</Grail>
		)
	}
}



// WEBPACK FOOTER //
// ./components/main.jsx